import { combineReducers}  from "redux";

import reducerHeader from "./reducer_header";
import reducerItineraries from "./reducer_itineraries";
import reducerAgencies from "./reducer_allagencies";
import reducerEvents from "./reducer_allevents";
import reducerTranslation from "./reducer_translation";
import reducerTripAgencies from "./reducer_tripagencies";

const rootReducer = combineReducers({
    events: reducerEvents,
    header: reducerHeader,
    itineraries: reducerItineraries,
    agencies: reducerAgencies,
    tripAgencies: reducerTripAgencies,
    translation: reducerTranslation,
});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/index.js